import { useContext } from "react";
import { NotificationContext } from "../Components/UI/NotificationProvider";

/**
 * Access the global notification system from any component.
 *
 * Usage:
 *   const { notifySuccess, notifyError } = useNotification();
 *   notifySuccess("Competition created.");
 *   notifyError("Something went wrong.");
 *
 * Must be used inside a NotificationProvider.
 */
const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error("useNotification must be used within a NotificationProvider");
  }
  return context;
};

export default useNotification;
